import { UserVeriffVerificationStatus } from './model/UserVeriffVerificationStatus';
import { ApiResponseError } from '../ApiResponseError';

export const getUserVeriffVerificationStatus: (sessionId?: string) => Promise<UserVeriffVerificationStatus> = async (
  sessionId,
) => {
  const url = sessionId
    ? `${process.env.VERIFF_SERVICE_BASE_URL}/api/verification?sessionId=${sessionId}`
    : `${process.env.VERIFF_SERVICE_BASE_URL}/api/verification`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  });

  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }

  return (await response.json()) as UserVeriffVerificationStatus;
};
